export default __webpack_public_path__ + "static/media/mode-66.6a5e7003.svg";